/**
 * Loading-bar bus — bridges async work (auth validation, project fetch,
 * lazy tab chunks) to the TopProgressBar without importing React.
 * Mirrors the notificationBus pattern.
 *
 *   const done = loadingBarStart();
 *   try { … } finally { done(); }
 *
 * Each start() returns a once-only done() closure; the bar is active
 * while ANY token is outstanding, so concurrent triggers can't collide
 * or double-release. Subscribers are notified on every transition and
 * immediately on subscribe (so a remounting bar re-syncs to in-flight
 * work).
 */

const activeTokens = new Set();
const subscribers = new Set();

const notifyAll = () => {
  const active = activeTokens.size > 0;
  subscribers.forEach((fn) => fn(active));
};

export function loadingBarStart() {
  const token = {};
  activeTokens.add(token);
  if (activeTokens.size === 1) notifyAll();
  let released = false;
  return function done() {
    if (released) return;
    released = true;
    activeTokens.delete(token);
    if (activeTokens.size === 0) notifyAll();
  };
}

export function subscribeLoadingBar(fn) {
  subscribers.add(fn);
  fn(activeTokens.size > 0);
  return () => {
    subscribers.delete(fn);
  };
}
